/** UI strings for the main tabs + retention features module (learn. pg. jr. st. tale. wc. mail. prog. skill.). */
export const en = {
  /* Learn */
  'learn.lockedTitle': 'Learn opens soon',
  'learn.lockedBody': 'Draw {n} more in the playground to open your first path.',
  'learn.switchPath': 'Switch path',
  'learn.choosePath': 'Choose your path',
  'learn.finishWarmup': 'Finish the warm-up to unlock',
  'learn.finishPrevious': 'Finish the previous lesson to unlock this one',
  'learn.needKey': 'Finish this level to earn the key for the next one',
  'learn.keyNeeded': 'Key needed',
  'learn.keyEarned': 'Level key earned',
  'learn.keyLocked': 'Finish this level to earn its key',
  'learn.stepsMin': '{n} steps · {m} min',
  'learn.resume': 'Keep going',
  'learn.done': 'done',
  'learn.pathDone': 'Path complete!',
  'learn.percent': '{n}% done',
  'learn.tryNext': 'Try next',
  'learn.youAreHere': 'You are here',
  'learn.coinTitle': 'Your artist coin',
  'learn.coinMissing': 'Collect {n} more pieces to complete it',
  'learn.coinDone': 'All three pieces! Brilliant!',
  'learn.coin.outline': 'Outline',
  'learn.coin.pattern': 'Pattern',
  'learn.coin.shading': 'Shading',
  'learn.endTitle': 'You finished {path}!',
  'learn.endBody': 'Where should your pencil go next?',
  'learn.dtTitle': 'Draw together',
  'learn.dtBody': 'Invite someone to draw the next lesson with you',

  /* Playground */
  'pg.categories': 'Categories',
  'pg.all': 'All',
  'pg.startHere': 'Start with one of these',
  'pg.myPicks': 'My picks',
  'pg.todayAsk': "What to draw today?",
  'pg.orTry': "Or try one of these",
  'pg.surprise': "Surprise me!",
  'pg.surpriseRolling': "Rolling the dice…",
  'pg.continue': "Keep going",
  'pg.new': "New for you",
  'pg.forYou': "Just for you",
  'pg.notTried': "Not tried yet",
  'pg.explore': "Explore everything",
  'pg.exploreHint': "Every drawing, sorted by type",
  'pg.catCount': "{n} drawings",
  'pg.recsFor': 'Picked for {name}',
  'pg.favorites': 'Favourites',
  'pg.favorite': 'Add to favourites',
  'pg.unfavorite': 'Remove from favourites',
  'pg.levelProgress': '{done} of {total} drawn',
  'pg.season.spring': 'Spring is here',
  'pg.season.summer': 'Sunny summer',
  'pg.season.autumn': 'Cosy autumn',
  'pg.season.winter': 'Winter wonders',
  'pg.season.holiday': 'Holiday treats',
  'pg.ftue.intro': 'Draw',
  'pg.ftue.learn': 'Open Learn',
  'pg.ftue.all': 'Open everything',
  'pg.ftue.drawMore': 'Draw {n} more to open Learn',
  'pg.ftue.oneMore': 'Just one more drawing to open Learn!',
  'pg.suggestTitle': 'Wish for a drawing',
  'pg.suggestBody': 'Tell us what you want to learn next',
  'pg.suggestPrompt': 'What would you love to draw? We read every wish.',
  'pg.suggestPlaceholder': 'A dragon eating ice cream…',
  'pg.suggestSend': 'Send my wish',
  'pg.suggestThanks': 'Wish sent! Thank you!',
  'pg.tips': 'Tips & tricks',
  'pg.tipsLocked': 'Keep collecting sparks to open the tips corner',
  'pg.tipFrom': 'From “{title}”',
  'pg.refLib': 'Reference library',
  'pg.refLocked': 'Every finished drawing in one big book, opening soon',

  /* Journal */
  'jr.lockedTitle': 'Your journal is almost here',
  'jr.lockedBody': 'Keep drawing to unlock your very own journal for all your art.',
  'jr.menu': 'Journal menu',
  'jr.menu.favs': 'Hearts',
  'jr.menu.layouts': 'Layout',
  'jr.menu.themes': 'Themes',
  'jr.menu.stickers': 'Stickers',
  'jr.menu.slideshow': 'Slideshow',
  'jr.menu.send': 'To Juno',
  'jr.menu.letters': 'Letters',
  'jr.menu.survey': 'Ideas',
  'jr.owner': "{name}'s journal",
  'jr.pageNo': 'p. {n}/{total}',
  'jr.emptyTitle': 'Your journal is waiting for its first drawing',
  'jr.emptyBody': 'Finish a lesson or tap + to add a photo of your art.',
  'jr.noFavs': 'Tap the heart on a drawing to keep it here',
  'jr.prevPage': 'Previous page',
  'jr.nextPage': 'Next page',
  'jr.add': 'Add a drawing',
  'jr.myDrawing': 'My drawing',
  'jr.layoutN': '{n} per page',
  'jr.theme.classic': 'Cork board',
  'jr.theme.notebook': 'Notebook',
  'jr.theme.gallery': 'Gallery',
  'jr.stickerHint': 'Drag a sticker onto the page. Tap a placed sticker to peel it off.',
  'jr.stickerLimit': 'This page is full: {n} stickers is the most',
  'jr.removeSticker': 'Remove sticker',
  'jr.rewardSticker': 'Weekly challenge reward',
  'jr.newStickers': '{n} new stickers just arrived!',
  'jr.decorate': 'Decorate my journal',
  'jr.newComplimentsOne': 'Hooray! A new compliment on your art',
  'jr.newCompliments': 'Hooray! {n} new compliments on your art',
  'jr.surveyTitle': 'What would make your journal even better?',
  'jr.surveyBody': 'Tell us your idea. A grown-up can help you write it.',
  'jr.surveySend': 'Send idea',
  'jr.surveyThanks': 'Thanks! We love new ideas.',
  'jr.titleLabel': 'Title',
  'jr.descLabel': 'About this drawing',
  'jr.descPlaceholder': 'What did you draw? How did it go?',
  'jr.feeling': 'How do you feel about it?',
  'jr.feel.1': 'Not happy',
  'jr.feel.2': 'A bit unsure',
  'jr.feel.3': 'Okay',
  'jr.feel.4': 'Happy',
  'jr.feel.5': 'Super proud',
  'jr.stars': '{n} stars',
  'jr.filter': 'Photo look',
  'jr.filter.none': 'Original',
  'jr.filter.clean': 'Crisp',
  'jr.filter.warm': 'Warm',
  'jr.filter.cool': 'Cool',
  'jr.filter.mono': 'Pencil',
  'jr.filter.pop': 'Pop',
  'jr.award.heart': 'Heart',
  'jr.award.rainbow': 'Rainbow',
  'jr.award.star': 'Star',
  'jr.award.trophy': 'Trophy',
  'jr.award.special': 'Something special',
  'jr.who.mom': 'Mum',
  'jr.who.dad': 'Dad',
  'jr.who.sibling': 'Brother or sister',
  'jr.who.grandparent': 'Grandparent',
  'jr.who.friend': 'Friend',
  'jr.who.other': 'Someone special',
  'jr.who.teacher': 'Teacher Juno',
  'jr.shareNoPhoto': 'Add a photo of this drawing to share it',
  'jr.unshare': 'Stop sharing',
  'jr.unshared': 'The share link is turned off',
  'jr.shareText': 'Look what {name} drew in Sketchling!',
  'jr.linkCopied': 'Link copied! Send it to someone far away.',
  'jr.hang': 'Hang in My Studio',
  'jr.onWall': 'On the wall',
  'jr.hung': 'Framed and hung in your studio!',
  'jr.deleteTitle': 'Remove this drawing?',
  'jr.deleteBody': 'It will leave your journal for good.',

  /* Studio */
  'st.title': 'My Studio',
  'st.disabled': 'The studio is resting right now. Come back soon!',
  'st.lockedTitle': 'Your studio is being built',
  'st.lockedBody': 'Collect sparks to open a cosy room where your best drawings hang on the wall.',
  'st.easelTag': 'Create!',
  'st.create': 'Create a 5-minute drawing',
  'st.emptyFrame': 'Empty frame',
  'st.wallHint': 'Finish a studio drawing to fill your first frame',
  'st.musicOn': 'Play studio music',
  'st.musicOff': 'Stop studio music',
  'st.takeDown': 'Take it down',
  'st.tut1': 'Welcome to your very own studio!',
  'st.tut2': 'Your best drawings hang here in frames.',
  'st.tut3': 'Tap the easel to make a quick 5-minute drawing.',
  'st.letsGo': "Let's go",
  'st.pickTitle': 'What shall we make?',
  'st.pickBody': 'Mix and match, then draw it step by step.',
  'st.minutes': '{n} min',
  'st.choices': '{n} choices',
  'st.notFound': 'This studio drawing is not here any more.',
  'st.preview': 'Your picture so far',
  'st.reference': 'Reference picture',
  'st.tools': 'Reference tools',
  'st.grid': 'Grid',
  'st.gridOff': 'No grid',
  'st.gridN': '{n} boxes',
  'st.gridCols': 'Columns',
  'st.flip': 'Flip',
  'st.zoomIn': 'Zoom in',
  'st.zoomOut': 'Zoom out',
  'st.startTimer': 'Start timer',
  'st.pauseTimer': 'Pause timer',
  'st.timesUp': "Time's up!",
  'st.prevOption': 'Previous option',
  'st.nextOption': 'Next option',
  'st.startDrawing': 'Start drawing',
  'st.nextPhase': 'Next part',
  'st.snap': 'Snap my drawing',
  'st.lookAtYou': 'Look what you made!',
  'st.looking': 'Taking a good look…',
  'st.yourDrawing': 'Your drawing',
  'st.hangIt': 'Hang it on my wall',

  /* Sketch Tales */
  'tale.title': 'Sketch Tales',
  'tale.disabled': 'Sketch Tales are taking a nap. Check back soon!',
  'tale.lockedTitle': 'Stories are on their way',
  'tale.lockedBody': 'Collect sparks to unlock Sketch Tales, little picture stories about Scribble.',
  'tale.introTitle': 'Want to watch the first episode?',
  'tale.introBody': 'Scribble has a story to tell. New episodes arrive every week!',
  'tale.watchNow': 'Watch now',
  'tale.episode': 'Episode {n}',
  'tale.nextIn': 'New episode in {time}',
  'tale.later': 'This one comes a bit later',
  'tale.moreSoon': 'More tales coming soon',
  'tale.newUnlocked': 'New episode unlocked!',
  'tale.next': 'Next scene',
  'tale.theEnd': 'The end of episode {n}',
  'tale.drawIt': 'Draw it',
  'tale.replay': 'Watch again',
  'tale.allEpisodes': 'All episodes',
  'tale.thanks': 'Great answer!',

  /* Weekly challenges */
  'wc.title': 'Weekly challenge',
  'wc.weekly': 'Weekly challenge',
  'wc.disabled': 'No challenges right now. Come back soon!',
  'wc.none': 'The next challenge is getting ready.',
  'wc.thisWeek': 'This week',
  'wc.endsIn': 'Ends in {time}',
  'wc.ended': 'Ended',
  'wc.startsIn': 'Starts in {time}',
  'wc.progress': '{n} of {total} drawings',
  'wc.addPhoto': 'Add a drawing from camera or gallery',
  'wc.expiredBody': 'This challenge is over. A new one starts soon!',
  'wc.openChest': 'Open the chest!',
  'wc.claimed': 'Reward collected',
  'wc.chestLocked': 'Reward chest (locked)',
  'wc.chestHint': '{n} to go',
  'wc.promoted': 'These drawings count',
  'wc.nextUp': 'Next week',
  'wc.introTitle': 'A new challenge every week!',
  'wc.introBody': 'Draw {n} drawings that fit the theme before time runs out, then open the chest for a sticker.',
  'wc.introCta': "I'm in!",
  'wc.rewardTitle': 'You earned a sticker!',
  'wc.rewardBody': 'Your reward is waiting in your journal.',
  'wc.toJournal': 'Open my journal',
  'wc.time.dh': '{d}d {h}h',
  'wc.time.hm': '{h}h {m}m',
  'wc.time.m': '{m}m',

  /* Teacher letters */
  'mail.title': 'Letters',
  'mail.disabled': 'Letters are paused right now.',
  'mail.lockedTitle': 'Letters from Teacher Juno',
  'mail.lockedBody': 'Collect sparks to send your drawings to Teacher Juno and get a real letter back.',
  'mail.moreDrawings': 'Just {n} more drawings to fill your envelope',
  'mail.oneMore': 'Just 1 more drawing to fill your envelope',
  'mail.drawNow': 'Draw something',
  'mail.full': 'Your envelope is full!',
  'mail.selectTitle': 'Pick {n} drawings for Teacher Juno',
  'mail.choose': 'Choose drawings',
  'mail.needDrawings': 'Add {n} more drawings to your journal first',
  'mail.max': 'You can pick {n} drawings',
  'mail.send': 'Send',
  'mail.onItsWay': 'On its way!',
  'mail.arrivesIn': 'Teacher Juno will write back in {time}',
  'mail.arrived': 'A letter from Teacher Juno just arrived!',
  'mail.inbox': 'Your letters',
  'mail.noLetters': 'No letters yet. Fill your envelope to send your first drawings.',
  'mail.letterN': 'Letter #{n}',
  'mail.fromJuno': 'A letter from Teacher Juno',

  /* Profile overview / sense of progress */
  'prog.title': 'My sparks',
  'prog.toNext': 'Collect {n} more sparks to reach level {m}',
  'prog.maxLevel': 'Top level! You are a true Sketchling star.',
  'prog.drawings': 'Drawings',
  'prog.together': 'Drawn together',
  'prog.stickers': 'Stickers',
  'prog.coin': 'Coin pieces',
  'prog.bonus': 'Bonus surprises',
  'prog.unlocked': 'Open',
  'prog.feature.journal': 'My journal',
  'prog.feature.tips': 'Tips & tricks',
  'prog.feature.letters': 'Letters from Juno',
  'prog.feature.stories': 'Sketch Tales',
  'prog.feature.studio': 'My Studio',
  'prog.feature.referenceLibrary': 'Reference library',
  'prog.keys': 'Path keys',
  'prog.more': 'Explore',
  'prog.addProfile': 'Add profile',
  'prog.keepDrawing': 'Keep drawing',
  'prog.notice.title': 'News',
  'prog.notice.none': 'All caught up!',
  'prog.notice.letterOne': 'A new letter from Teacher Juno',
  'prog.notice.letters': '{n} new letters from Teacher Juno',
  'prog.notice.envelope': 'Your envelope is full: send it to Juno',
  'prog.notice.chest': 'Your challenge chest is ready',
  'prog.notice.taleOne': 'A new Sketch Tales episode',
  'prog.notice.tales': '{n} new Sketch Tales episodes',

  /* Skills */
  'skill.title': 'Skills',
  'skill.intro': 'Every drawing makes these skills grow. Tap one to see its lessons.',
  'skill.disabled': 'Skills are hidden right now.',
  'skill.level': 'Level {n}/{max}',
  'skill.badges': '{n} badges',
  'skill.mastery': 'Mastery {n}%',
  'skill.xpToNext': '{n} more practice points to the next level',
  'skill.mastered': 'Skill mastered!',
  'skill.masteredShort': 'You have mastered this skill',
  'skill.classroom': 'Classroom',
};

export const vi: Record<keyof typeof en, string> = {
  'learn.lockedTitle': 'Học vẽ sắp mở rồi',
  'learn.lockedBody': 'Vẽ thêm {n} bức ở sân chơi để mở lộ trình đầu tiên.',
  'learn.switchPath': 'Đổi lộ trình',
  'learn.choosePath': 'Chọn lộ trình của con',
  'learn.finishWarmup': 'Hoàn thành phần khởi động để mở khoá',
  'learn.finishPrevious': 'Hoàn thành bài trước để mở khoá bài này nhé',
  'learn.needKey': 'Hoàn thành cấp này để nhận chìa khoá mở cấp sau',
  'learn.keyNeeded': 'Cần chìa khoá',
  'learn.keyEarned': 'Đã nhận chìa khoá cấp',
  'learn.keyLocked': 'Hoàn thành cấp này để nhận chìa khoá',
  'learn.stepsMin': '{n} bước · {m} phút',
  'learn.resume': 'Vẽ tiếp',
  'learn.done': 'đã xong',
  'learn.pathDone': 'Hoàn thành lộ trình!',
  'learn.percent': 'Đã xong {n}%',
  'learn.tryNext': 'Thử tiếp',
  'learn.youAreHere': 'Con đang ở đây',
  'learn.coinTitle': 'Đồng xu hoạ sĩ',
  'learn.coinMissing': 'Thu thêm {n} mảnh nữa để ghép đủ',
  'learn.coinDone': 'Đủ cả ba mảnh! Tuyệt vời!',
  'learn.coin.outline': 'Nét viền',
  'learn.coin.pattern': 'Hoa văn',
  'learn.coin.shading': 'Tô bóng',
  'learn.endTitle': 'Con đã hoàn thành {path}!',
  'learn.endBody': 'Cây bút chì của con muốn đi đâu tiếp nào?',
  'learn.dtTitle': 'Cùng vẽ nhé',
  'learn.dtBody': 'Rủ một người cùng vẽ bài tiếp theo với con',

  'pg.categories': 'Danh mục',
  'pg.all': 'Tất cả',
  'pg.startHere': 'Bắt đầu với một hình này nhé',
  'pg.myPicks': 'Con thích',
  'pg.todayAsk': "Hôm nay vẽ gì nhỉ?",
  'pg.orTry': "Hoặc thử một hình này",
  'pg.surprise': "Bất ngờ đi!",
  'pg.surpriseRolling': "Đang tung xúc xắc…",
  'pg.continue': "Vẽ tiếp nào",
  'pg.new': "Mới mở cho con",
  'pg.forYou': "Dành riêng cho con",
  'pg.notTried': "Con chưa thử",
  'pg.explore': "Khám phá tất cả",
  'pg.exploreHint': "Mọi hình vẽ, xếp theo loại",
  'pg.catCount': "{n} hình",
  'pg.recsFor': 'Chọn riêng cho {name}',
  'pg.favorites': 'Yêu thích',
  'pg.favorite': 'Thêm vào yêu thích',
  'pg.unfavorite': 'Bỏ khỏi yêu thích',
  'pg.levelProgress': 'Đã vẽ {done}/{total}',
  'pg.season.spring': 'Mùa xuân đến rồi',
  'pg.season.summer': 'Mùa hè rực nắng',
  'pg.season.autumn': 'Mùa thu ấm áp',
  'pg.season.winter': 'Mùa đông kỳ diệu',
  'pg.season.holiday': 'Quà ngày lễ',
  'pg.ftue.intro': 'Vẽ',
  'pg.ftue.learn': 'Mở Học vẽ',
  'pg.ftue.all': 'Mở tất cả',
  'pg.ftue.drawMore': 'Vẽ thêm {n} bức để mở Học vẽ',
  'pg.ftue.oneMore': 'Chỉ một bức nữa là mở Học vẽ!',
  'pg.suggestTitle': 'Ước một bức vẽ',
  'pg.suggestBody': 'Kể cho chúng mình con muốn học vẽ gì tiếp',
  'pg.suggestPrompt': 'Con thích vẽ gì nhất? Chúng mình đọc từng điều ước.',
  'pg.suggestPlaceholder': 'Một chú rồng ăn kem…',
  'pg.suggestSend': 'Gửi điều ước',
  'pg.suggestThanks': 'Đã gửi điều ước! Cảm ơn con!',
  'pg.tips': 'Mẹo hay',
  'pg.tipsLocked': 'Tiếp tục thu tia sáng để mở góc mẹo hay',
  'pg.tipFrom': 'Từ bài “{title}”',
  'pg.refLib': 'Thư viện hình mẫu',
  'pg.refLocked': 'Mọi bức vẽ hoàn chỉnh trong một cuốn sách lớn, sắp mở rồi',

  'jr.lockedTitle': 'Sổ tranh sắp xuất hiện',
  'jr.lockedBody': 'Vẽ tiếp để mở khoá cuốn sổ tranh của riêng con.',
  'jr.menu': 'Menu sổ tranh',
  'jr.menu.favs': 'Tim',
  'jr.menu.layouts': 'Bố cục',
  'jr.menu.themes': 'Giao diện',
  'jr.menu.stickers': 'Nhãn dán',
  'jr.menu.slideshow': 'Trình chiếu',
  'jr.menu.send': 'Gửi cô Juno',
  'jr.menu.letters': 'Thư',
  'jr.menu.survey': 'Ý tưởng',
  'jr.owner': 'Sổ tranh của {name}',
  'jr.pageNo': 'tr. {n}/{total}',
  'jr.emptyTitle': 'Sổ tranh đang chờ bức vẽ đầu tiên',
  'jr.emptyBody': 'Học xong một bài hoặc chạm + để thêm ảnh tranh của con.',
  'jr.noFavs': 'Chạm trái tim trên một bức vẽ để giữ nó ở đây',
  'jr.prevPage': 'Trang trước',
  'jr.nextPage': 'Trang sau',
  'jr.add': 'Thêm bức vẽ',
  'jr.myDrawing': 'Tranh của con',
  'jr.layoutN': '{n} tranh mỗi trang',
  'jr.theme.classic': 'Bảng ghim',
  'jr.theme.notebook': 'Vở kẻ',
  'jr.theme.gallery': 'Phòng tranh',
  'jr.stickerHint': 'Kéo nhãn dán lên trang. Chạm vào nhãn đã dán để bóc ra.',
  'jr.stickerLimit': 'Trang này đầy rồi: tối đa {n} nhãn dán',
  'jr.removeSticker': 'Bóc nhãn dán',
  'jr.rewardSticker': 'Phần thưởng thử thách tuần',
  'jr.newStickers': 'Vừa có {n} nhãn dán mới!',
  'jr.decorate': 'Trang trí sổ tranh',
  'jr.newComplimentsOne': 'Hoan hô! Có một lời khen mới cho tranh của con',
  'jr.newCompliments': 'Hoan hô! Có {n} lời khen mới cho tranh của con',
  'jr.surveyTitle': 'Điều gì sẽ làm sổ tranh hay hơn nữa?',
  'jr.surveyBody': 'Kể cho chúng mình ý tưởng của con. Người lớn có thể giúp con viết.',
  'jr.surveySend': 'Gửi ý tưởng',
  'jr.surveyThanks': 'Cảm ơn con! Chúng mình rất thích ý tưởng mới.',
  'jr.titleLabel': 'Tên tranh',
  'jr.descLabel': 'Về bức vẽ này',
  'jr.descPlaceholder': 'Con đã vẽ gì? Con vẽ thấy thế nào?',
  'jr.feeling': 'Con thấy bức vẽ thế nào?',
  'jr.feel.1': 'Chưa vui',
  'jr.feel.2': 'Hơi phân vân',
  'jr.feel.3': 'Tạm được',
  'jr.feel.4': 'Vui',
  'jr.feel.5': 'Siêu tự hào',
  'jr.stars': '{n} ngôi sao',
  'jr.filter': 'Màu ảnh',
  'jr.filter.none': 'Gốc',
  'jr.filter.clean': 'Rõ nét',
  'jr.filter.warm': 'Ấm',
  'jr.filter.cool': 'Mát',
  'jr.filter.mono': 'Bút chì',
  'jr.filter.pop': 'Rực rỡ',
  'jr.award.heart': 'Trái tim',
  'jr.award.rainbow': 'Cầu vồng',
  'jr.award.star': 'Ngôi sao',
  'jr.award.trophy': 'Cúp',
  'jr.award.special': 'Điều đặc biệt',
  'jr.who.mom': 'Mẹ',
  'jr.who.dad': 'Bố',
  'jr.who.sibling': 'Anh chị em',
  'jr.who.grandparent': 'Ông bà',
  'jr.who.friend': 'Bạn',
  'jr.who.other': 'Một người đặc biệt',
  'jr.who.teacher': 'Cô Juno',
  'jr.shareNoPhoto': 'Thêm ảnh bức vẽ này để chia sẻ nhé',
  'jr.unshare': 'Ngừng chia sẻ',
  'jr.unshared': 'Đã tắt link chia sẻ',
  'jr.shareText': 'Xem {name} đã vẽ gì trên Sketchling nè!',
  'jr.linkCopied': 'Đã sao chép liên kết! Gửi cho người ở xa nhé.',
  'jr.hang': 'Treo trong Xưởng vẽ',
  'jr.onWall': 'Đã treo',
  'jr.hung': 'Đã đóng khung và treo trong xưởng vẽ!',
  'jr.deleteTitle': 'Xoá bức vẽ này?',
  'jr.deleteBody': 'Bức vẽ sẽ rời khỏi sổ tranh mãi mãi.',

  'st.title': 'Xưởng vẽ',
  'st.disabled': 'Xưởng vẽ đang nghỉ. Con quay lại sau nhé!',
  'st.lockedTitle': 'Xưởng vẽ đang được xây',
  'st.lockedBody': 'Thu tia sáng để mở căn phòng ấm cúng, nơi treo những bức vẽ đẹp nhất của con.',
  'st.easelTag': 'Vẽ nào!',
  'st.create': 'Vẽ nhanh 5 phút',
  'st.emptyFrame': 'Khung trống',
  'st.wallHint': 'Hoàn thành một bức vẽ ở xưởng để lấp khung đầu tiên',
  'st.musicOn': 'Bật nhạc xưởng vẽ',
  'st.musicOff': 'Tắt nhạc xưởng vẽ',
  'st.takeDown': 'Gỡ xuống',
  'st.tut1': 'Chào mừng con đến xưởng vẽ của riêng mình!',
  'st.tut2': 'Những bức vẽ đẹp nhất được đóng khung treo ở đây.',
  'st.tut3': 'Chạm vào giá vẽ để vẽ nhanh trong 5 phút.',
  'st.letsGo': 'Bắt đầu thôi',
  'st.pickTitle': 'Mình vẽ gì đây?',
  'st.pickBody': 'Chọn và phối thật vui, rồi vẽ từng bước.',
  'st.minutes': '{n} phút',
  'st.choices': '{n} lựa chọn',
  'st.notFound': 'Bức vẽ ở xưởng này không còn nữa.',
  'st.preview': 'Bức tranh của con lúc này',
  'st.reference': 'Hình mẫu',
  'st.tools': 'Công cụ hình mẫu',
  'st.grid': 'Lưới',
  'st.gridOff': 'Không lưới',
  'st.gridN': '{n} ô',
  'st.gridCols': 'Cột',
  'st.flip': 'Lật',
  'st.zoomIn': 'Phóng to',
  'st.zoomOut': 'Thu nhỏ',
  'st.startTimer': 'Bắt đầu hẹn giờ',
  'st.pauseTimer': 'Tạm dừng hẹn giờ',
  'st.timesUp': 'Hết giờ!',
  'st.prevOption': 'Lựa chọn trước',
  'st.nextOption': 'Lựa chọn sau',
  'st.startDrawing': 'Bắt đầu vẽ',
  'st.nextPhase': 'Phần tiếp',
  'st.snap': 'Chụp tranh của con',
  'st.lookAtYou': 'Xem con vẽ được gì nè!',
  'st.looking': 'Đang ngắm thật kỹ…',
  'st.yourDrawing': 'Tranh của con',
  'st.hangIt': 'Treo lên tường',

  'tale.title': 'Chuyện Phác Thảo',
  'tale.disabled': 'Chuyện Phác Thảo đang ngủ trưa. Con quay lại sau nhé!',
  'tale.lockedTitle': 'Truyện đang tới rồi',
  'tale.lockedBody': 'Thu tia sáng để mở Chuyện Phác Thảo, những truyện tranh nhỏ về Scribble.',
  'tale.introTitle': 'Con muốn xem tập đầu tiên không?',
  'tale.introBody': 'Scribble có một câu chuyện muốn kể. Mỗi tuần lại có tập mới!',
  'tale.watchNow': 'Xem ngay',
  'tale.episode': 'Tập {n}',
  'tale.nextIn': 'Tập mới sau {time}',
  'tale.later': 'Tập này sẽ đến sau một chút',
  'tale.moreSoon': 'Sắp có thêm truyện mới',
  'tale.newUnlocked': 'Đã mở tập mới!',
  'tale.next': 'Cảnh tiếp theo',
  'tale.theEnd': 'Hết tập {n}',
  'tale.drawIt': 'Vẽ ngay',
  'tale.replay': 'Xem lại',
  'tale.allEpisodes': 'Tất cả các tập',
  'tale.thanks': 'Câu trả lời tuyệt quá!',

  'wc.title': 'Thử thách tuần',
  'wc.weekly': 'Thử thách tuần',
  'wc.disabled': 'Hiện chưa có thử thách. Con quay lại sau nhé!',
  'wc.none': 'Thử thách tiếp theo đang được chuẩn bị.',
  'wc.thisWeek': 'Tuần này',
  'wc.endsIn': 'Còn {time}',
  'wc.ended': 'Đã kết thúc',
  'wc.startsIn': 'Bắt đầu sau {time}',
  'wc.progress': '{n}/{total} bức vẽ',
  'wc.addPhoto': 'Thêm tranh từ máy ảnh hoặc thư viện',
  'wc.expiredBody': 'Thử thách này đã kết thúc. Thử thách mới sắp bắt đầu!',
  'wc.openChest': 'Mở rương thôi!',
  'wc.claimed': 'Đã nhận thưởng',
  'wc.chestLocked': 'Rương thưởng (đang khoá)',
  'wc.chestHint': 'Còn {n} bức',
  'wc.promoted': 'Những bức vẽ này được tính',
  'wc.nextUp': 'Tuần sau',
  'wc.introTitle': 'Mỗi tuần một thử thách mới!',
  'wc.introBody': 'Vẽ {n} bức hợp chủ đề trước khi hết giờ, rồi mở rương để nhận nhãn dán.',
  'wc.introCta': 'Con tham gia!',
  'wc.rewardTitle': 'Con nhận được một nhãn dán!',
  'wc.rewardBody': 'Phần thưởng đang chờ con trong sổ tranh.',
  'wc.toJournal': 'Mở sổ tranh',
  'wc.time.dh': '{d} ngày {h} giờ',
  'wc.time.hm': '{h} giờ {m} phút',
  'wc.time.m': '{m} phút',

  'mail.title': 'Thư',
  'mail.disabled': 'Tính năng thư đang tạm dừng.',
  'mail.lockedTitle': 'Thư từ cô Juno',
  'mail.lockedBody': 'Thu tia sáng để gửi tranh cho cô Juno và nhận một lá thư thật sự.',
  'mail.moreDrawings': 'Chỉ cần {n} bức nữa là đầy phong bì',
  'mail.oneMore': 'Chỉ cần 1 bức nữa là đầy phong bì',
  'mail.drawNow': 'Vẽ gì đó nào',
  'mail.full': 'Phong bì đã đầy!',
  'mail.selectTitle': 'Chọn {n} bức vẽ gửi cô Juno',
  'mail.choose': 'Chọn tranh',
  'mail.needDrawings': 'Thêm {n} bức vào sổ tranh trước nhé',
  'mail.max': 'Con được chọn {n} bức',
  'mail.send': 'Gửi',
  'mail.onItsWay': 'Thư đang đi!',
  'mail.arrivesIn': 'Cô Juno sẽ viết thư trả lời sau {time}',
  'mail.arrived': 'Thư của cô Juno vừa đến!',
  'mail.inbox': 'Thư của con',
  'mail.noLetters': 'Chưa có thư nào. Làm đầy phong bì để gửi những bức vẽ đầu tiên.',
  'mail.letterN': 'Thư số {n}',
  'mail.fromJuno': 'Thư từ cô Juno',

  'prog.title': 'Tia sáng của con',
  'prog.toNext': 'Thu thêm {n} tia sáng để lên cấp {m}',
  'prog.maxLevel': 'Cấp cao nhất! Con là ngôi sao Sketchling thực thụ.',
  'prog.drawings': 'Bức vẽ',
  'prog.together': 'Vẽ cùng nhau',
  'prog.stickers': 'Nhãn dán',
  'prog.coin': 'Mảnh xu',
  'prog.bonus': 'Bất ngờ thưởng thêm',
  'prog.unlocked': 'Đã mở',
  'prog.feature.journal': 'Sổ tranh',
  'prog.feature.tips': 'Mẹo hay',
  'prog.feature.letters': 'Thư từ cô Juno',
  'prog.feature.stories': 'Chuyện Phác Thảo',
  'prog.feature.studio': 'Xưởng vẽ',
  'prog.feature.referenceLibrary': 'Thư viện hình mẫu',
  'prog.keys': 'Chìa khoá lộ trình',
  'prog.more': 'Khám phá',
  'prog.addProfile': 'Thêm hồ sơ',
  'prog.keepDrawing': 'Vẽ tiếp nào',
  'prog.notice.title': 'Tin mới',
  'prog.notice.none': 'Con đã xem hết rồi!',
  'prog.notice.letterOne': 'Một thư mới từ cô Juno',
  'prog.notice.letters': '{n} thư mới từ cô Juno',
  'prog.notice.envelope': 'Phong bì đã đầy: gửi cho cô Juno nhé',
  'prog.notice.chest': 'Rương thử thách đã sẵn sàng',
  'prog.notice.taleOne': 'Một tập Chuyện Phác Thảo mới',
  'prog.notice.tales': '{n} tập Chuyện Phác Thảo mới',

  'skill.title': 'Kỹ năng',
  'skill.intro': 'Mỗi bức vẽ giúp các kỹ năng này lớn lên. Chạm vào một kỹ năng để xem bài học.',
  'skill.disabled': 'Kỹ năng đang được ẩn.',
  'skill.level': 'Cấp {n}/{max}',
  'skill.badges': '{n} huy hiệu',
  'skill.mastery': 'Thành thạo {n}%',
  'skill.xpToNext': 'Còn {n} điểm luyện tập để lên cấp',
  'skill.mastered': 'Đã thành thạo kỹ năng!',
  'skill.masteredShort': 'Con đã thành thạo kỹ năng này',
  'skill.classroom': 'Lớp học',
};
